import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import SavedReportModel from "../../models/saved-report-filter";

export default class TabularReportRepository extends BaseRepository {
  static modelClass = SavedReportModel;
  modelName = "saved-report-filter";
  safe = true;
}
